(function () {
  function init(section) {
    const hotspots = Array.from(section.querySelectorAll(".sd-hotspots__hotspot"));
    const pagerDots = Array.from(section.querySelectorAll(".sd-hotspots__pagerdot"));

    const linkEl = section.querySelector("[data-featured-link]");
    const imgEl = section.querySelector("[data-featured-image]");
    const titleEl = section.querySelector("[data-featured-title]");
    const priceEl = section.querySelector("[data-featured-price]");

    if (!hotspots.length || !linkEl || !imgEl || !titleEl || !priceEl) return;

    let active = 0;
    let closeTimer = null;

    function parseData(hotspot) {
      const tpl = hotspot.querySelector(".sd-hotspots__data");
      if (!tpl) return null;
      try { return JSON.parse(tpl.innerHTML.trim()); } catch (e) { return null; }
    }

    function closeAllTooltips() {
      hotspots.forEach(h => h.dataset.open = "false");
    }

    function setActive(index, { openTooltip = true } = {}) {
      active = Math.max(0, Math.min(index, hotspots.length - 1));

      const hotspot = hotspots[active];
      const data = parseData(hotspot);

      // Update right panel if product exists
      if (data) {
        linkEl.href = data.url;
        imgEl.src = data.image;
        imgEl.alt = data.title;
        titleEl.textContent = data.title;
        priceEl.textContent = data.price;
      } else {
        linkEl.href = "#";
        imgEl.removeAttribute("src");
        imgEl.alt = "";
        titleEl.textContent = "Select a product for this hotspot";
        priceEl.textContent = "";
      }

      // Tooltips + pager state
      closeAllTooltips();
      if (openTooltip) hotspot.dataset.open = "true";

      pagerDots.forEach((b, i) => b.setAttribute("aria-selected", String(i === active)));
    }

    hotspots.forEach((hotspot, i) => {
      const btn = hotspot.querySelector(".sd-hotspots__dot");

      const open = () => setActive(i, { openTooltip: true });

      btn.addEventListener("mouseenter", open);
      btn.addEventListener("focus", open);
      btn.addEventListener("click", open);

      hotspot.addEventListener("mouseenter", () => {
        if (closeTimer) clearTimeout(closeTimer);
      });
      hotspot.addEventListener("mouseleave", () => {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(() => closeAllTooltips(), 350);
      });
    });

    pagerDots.forEach((dot) => {
      dot.addEventListener("click", () => {
        const idx = Number(dot.dataset.index || 0);
        setActive(idx, { openTooltip: false });
      });
    });

    setActive(0, { openTooltip: true });
  }

  // Shopify theme editor + normal load
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".sd-hotspots").forEach(init);
  });

  document.addEventListener("shopify:section:load", (e) => {
    const section = e.target && e.target.querySelector(".sd-hotspots");
    if (section) init(section);
  });
})();